/**
 * DevAdminBadge — tiny visible "Development Admin" pill that renders on
 * any admin page when the current user has `is_seed_admin === true`.
 *
 * Purpose: production operators must never mistake the dev seed admin
 * for a real production admin (2026-05-10).  Renders fixed in the
 * top-right corner of the admin UI; respects RTL.
 *
 * Strictly presentational. No state, no side effects.
 */
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

export default function DevAdminBadge() {
  const { user } = useAuth();
  const { i18n } = useTranslation();
  if (!user || !user.is_seed_admin) return null;
  const isRTL = i18n.language?.startsWith('ar');
  return (
    <>
      <div
        className="dev-admin-badge"
        data-testid="dev-admin-badge"
        title={isRTL
          ? 'حساب تطوير — لا تستخدمه في الإنتاج'
          : 'Development admin account — do not use in production'}
      >
        <AlertTriangle size={12} />
        <span>{isRTL ? 'حساب تطوير' : 'DEV ADMIN'}</span>
      </div>
      <style>{`
        .dev-admin-badge {
          position: fixed;
          top: 8px;
          ${isRTL ? 'left' : 'right'}: 8px;
          z-index: 9999;
          display: inline-flex;
          align-items: center;
          gap: 4px;
          padding: 4px 8px;
          background: #f59e0b;
          color: #1f2937;
          font-size: 10px;
          font-weight: 800;
          letter-spacing: 0.4px;
          border-radius: 999px;
          box-shadow: 0 2px 6px rgba(0,0,0,0.18);
          pointer-events: none;
          user-select: none;
        }
      `}</style>
    </>
  );
}
